import validateCnpj from "./cnpj";
import validateCpf from "./cpf";

export default (val = "", type = "") => {
  const s = globalThis.$utils.cpfCnpjMask(val, true);

  if (s.length === 14) {
    if (type && type !== "J") {
      return false;
    }
    return validateCnpj(s);
  }
  if (s.length === 11) {
    if (type && type !== "F") {
      return false;
    }
    return validateCpf(s);
  }
  return false;
};
